module.exports = __webpack_public_path__ + "img/orange-juice.b5020c1d.svg";